export const formatNumber = (amount: number) => {
  if (amount % 1 === 0) {
    return amount.toString();
  } else {
    return amount.toFixed(2).toString().replace(".", ",");
  }
};
